import { useState } from 'preact/hooks';
import '../css/coming-soon.css';
import { comingSoonContent } from '../content';
import { submitFeedback } from '../functions/apis/feedbackService';



export const ComingSoon = () => {
  const { subtitle, feedback, cards } = comingSoonContent;
  const [suggestion, setSuggestion] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null);

  const handleSubmit = async (e: Event) => {
    e.preventDefault();

    if (!suggestion.trim()) {
      setMessage({ type: 'error', text: feedback.emptyError });
      return;
    }

    setIsSubmitting(true);
    setMessage(null);

    try {
      console.log('Submitting feedback:', suggestion);
      const response = await submitFeedback(suggestion);
      console.log('Feedback submitted successfully:', response);
      setMessage({ type: 'success', text: feedback.success });
      setSuggestion('');
    } catch (error: any) {
      console.error('Error submitting feedback:', error);
      let errorMessage = feedback.genericError;

      if (error instanceof Error) {
        errorMessage = error.message;
      } else if (error.detail) {
        errorMessage = error.detail;
      } else if (error.message) {
        errorMessage = error.message;
      }

      setMessage({
        type: 'error',
        text: errorMessage,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="coming-soon-container">
      <div className="in-the-works-container">
        <p className="coming-soon-subtitle">{subtitle}</p>

        <form className="suggestion-form" onSubmit={handleSubmit}>
          <div className="suggestion-composer">
            <textarea
              className="suggestion-input"
              placeholder={feedback.placeholder}
              value={suggestion}
              rows={3}
              onInput={(e) => setSuggestion((e.target as HTMLTextAreaElement).value)}
              disabled={isSubmitting}
            />
            <div className="suggestion-composer-footer">
              <button type="submit" className="suggestion-button" disabled={isSubmitting}>
                {isSubmitting ? feedback.submittingLabel : feedback.submitLabel}
              </button>
            </div>
          </div>
        </form>

        {message && (
          <div className={`feedback-message ${message.type}`}>
            {message.text}
          </div>
        )}
      </div>

      <div className="cards-container">
        <div className="upcoming-work-grid">
          {cards.map((card) => {
            const hasProgress = typeof card.progress === 'number';
            const progress = hasProgress
              ? Math.min(100, Math.max(0, card.progress))
              : 0;

            return (
              <article key={card.id} className="upcoming-work-card">
                <div className="work-card-header">
                  <div className="work-card-icon" aria-hidden="true">
                    <i className={card.icon} />
                  </div>
                  <h3 className="work-card-title">{card.title}</h3>
                </div>
                <p className="work-card-description">{card.description}</p>
                {hasProgress && (
                  <div
                    className="work-card-progress"
                    role="progressbar"
                    aria-valuemin={0}
                    aria-valuemax={100}
                    aria-valuenow={progress}
                    aria-label={`${card.title} progress`}
                  >
                    <div className="work-card-progress-header">
                      <span className="work-card-progress-label">Progress</span>
                      <span className="work-card-progress-value">{progress}%</span>
                    </div>
                    <div className="work-card-progress-track">
                      <div
                        className="work-card-progress-fill"
                        style={{ width: `${progress}%` }}
                      />
                    </div>
                  </div>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </div>
  );
};
